function H1() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Г1 Лідерська
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="3">
                        Г1.1 Здатність до самопрезентації та презентації діяльності закладу дошкільної освіти
                    </td>
                    <td>
                        Г1.1.31 Основи освітнього маркетингу
                    </td>
                    <td>
                        Г1.1.У1 Визначати переваги та недоліки функціонування закладу дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.1.32 Техніки і методики вербальної та невербальної демонстрації власної особистості в системі комунікації, основи іміджелогії
                    </td>
                    <td>
                        Г1.1.У2 Формувати позитивне враження про керівника і заклад дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.1.33 Технології здійснення позитивного впливу на колектив закладу, окремих осіб і групи осіб
                    </td>
                    <td>
                        Г1.1.УЗ Застосовувати технології здійснення позитивного впливу на колектив закладу, окремих осіб і групи осіб, формувати лідерські якості та демонструвати їх в процесі управління людьми
                    </td>
                </tr>

                <tr>

                    <td rowSpan="4">
                        Г1.2 Здатність до адаптивності та стресостійкості, швидкого реагування на зміни під час професійної діяльності
                    </td>
                    <td>
                        Г1.2.31 Теорія змін
                    </td>
                    <td>
                        Г1.2.У1 Управляти змінами під час професійної діяльності та проявляти гнучкість і адаптивність залежно від ситуації
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.2.32 Поняття, ознаки, стадії, види стресу, класифікацію основних стресорів в професійній діяльності
                    </td>
                    <td>
                        Г1.2.У2 Аналізувати причини стресорів у професійній діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.2.33 Основні ресурси стресостійкості особистості
                    </td>
                    <td>
                        Г1.2.УЗ Застосовувати техніки зниження емоційної напруги, регуляції стресового стану під час професійної взаємодії
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.2.34 Теорія лідерства та розвиток лідерських якостей особистості
                    </td>
                    <td>
                        Г1.2.У4 Розвивати лідерські якості та використовувати їх у професійній діяльності
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        Г1.3 Здатність до ефективного врегулювання конфліктів та профілактики професійного вигорання
                    </td>
                    <td>
                        Г1.3.31 Основи конфлікто-логії, методи попередження та вирішення конфліктів
                    </td>
                    <td>
                        Г1.3.У1 Виявляти причини конфлікту та конструктивно вирішувати конфліктні ситуації
                    </td>
                </tr>
                <tr>
                    <td>
                        Г1.3.32 Сутність, ознаки, причини професійного вигорання та способи його попередження і подолання
                    </td>
                    <td>
                        Г1.3.У2 Виявляти ознаки професійного вигорання, вживати адекватні способи для попередження та подолання професійного вигорання педагогічних працівників
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {H1}